import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMongoDbIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 48,
		height: 48,
		rx: 8,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M26.6097 12.3437C25.3506 10.8498 24.2664 9.33262 24.0449 9.01751C24.0215 8.99416 23.9866 8.99416 23.9632 9.01751C23.7417 9.33262 22.6575 10.8498 21.3984 12.3437C10.5912 26.127 23.1005 35.4287 23.1005 35.4287L23.2055 35.4988C23.2987 36.9342 23.5319 39 23.5319 39H23.9982H24.4646C24.4646 39 24.6977 36.9459 24.791 35.4988L24.8959 35.417C24.9076 35.4287 37.4169 26.127 26.6097 12.3437ZM23.9982 35.2186C23.9982 35.2186 23.4386 34.7401 23.2871 34.4951V34.4716L23.9632 19.4629C23.9632 19.4163 24.0332 19.4163 24.0332 19.4629L24.7094 34.4716V34.4951C24.5578 34.7401 23.9982 35.2186 23.9982 35.2186Z",
		fill: "#001E2B"
	})]
});
export default SvgMongoDbIcon;
